import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import React, { useState } from 'react';

import getStripeElementsStyle from '../../../constants/stripeElementsStyle';
import { useTheme } from '../../../theme/useTheme';
import Text from '../../Text';
import { ErrorToast } from '../../Toast';
import PayButton from './PayButton';

interface Props {
  onPay: (stripeToken: string) => Promise<void>;
}

function CardPayment({ onPay }: Props) {
  const [error, setError] = useState<string>();

  const { theme } = useTheme();
  const stripeElementsStyle = getStripeElementsStyle(theme);

  return (
    <div className="mt-2">
      <div className="text-2xl">Pay with card</div>
      <div className="mt-4 mb-2">
        <Text variant="muted">Card Information</Text>
      </div>
      <div>
        <div className="border rounded-t border-base p-4">
          <CardNumberElement options={{ style: stripeElementsStyle }} className="align-middle w-full" />
        </div>
        <div>
          <div className="inline-block w-2/4 border border-t-0 border-r-0 rounded-bl border-base p-4">
            <CardExpiryElement options={{ style: stripeElementsStyle }} className="align-middle" />
          </div>
          <div className="inline-block w-2/4 border border-t-0 rounded-br border-base p-4">
            <CardCvcElement options={{ style: stripeElementsStyle }} className="align-middle" />
          </div>
        </div>
        {error && <ErrorToast className="p-2 mt-2">{error}</ErrorToast>}
        <PayButton onPay={onPay} onError={setError} />
      </div>
    </div>
  );
}

export default React.memo(CardPayment);
